import axios from 'axios';

import { getAuthorizationHeader } from './auth_service';

export const createTeamHistory = async (data) => {
  let res = await axios.post(process.env.REACT_APP_BACKEND_URL + 'api/team-histories', {data: data},
      getAuthorizationHeader())

  return res.data.data;
}


export const putTeamHistory = async (id, data) => {
  let res = await axios.put(process.env.REACT_APP_BACKEND_URL + `api/team-histories/${id}`, {data: data},
      getAuthorizationHeader())

  return res.data.data;
}

export const deleteTeamHistory = async (id) => {
  let res = await axios.delete(process.env.REACT_APP_BACKEND_URL + `api/team-histories/${id}`,
      getAuthorizationHeader())

  return res.data.data;
}